// src/pages/couriers/components/DeleteRuleModal.jsx
import React from 'react';
import { X, AlertCircle, Trash2, RefreshCw } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './DeleteRuleModal.module.css';

const DeleteRuleModal = ({ isOpen, onClose, rule, onConfirm, isSubmitting }) => {
  const { t } = useLocalization();

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={`${styles.modal} ${styles.deleteModal}`} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>
            <AlertCircle size={20} />
            {t('couriers.confirmDeletion')}
          </h2>
          <button onClick={onClose} className={styles.closeButton}>
            <X size={20} />
          </button>
        </div>
        <div className={styles.modalContent}>
          <p>
            {t('couriers.deleteRuleConfirmation')} <strong>{rule?.name}</strong>?
          </p>
          <p className={styles.warningText}>
            {t('couriers.deleteRuleWarning')}
          </p>
        </div>
        <div className={styles.modalFooter}>
          <button onClick={onClose} className={styles.secondaryButton} disabled={isSubmitting}>
            {t('couriers.cancel')}
          </button>
          <button onClick={onConfirm} className={styles.dangerButton} disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <RefreshCw size={16} className={styles.spinning} />
                {t('couriers.deleting')}
              </>
            ) : (
              <>
                <Trash2 size={16} />
                {t('couriers.deleteRule')}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteRuleModal;